<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card class="overflow-hidden">
        <div slot="no-body">
            <div class="p-6" :class="{
              'flex justify-between flex-row-reverse items-center': iconRight,
              'text-center': !iconRight && hideChart,
              'pb-0': !hideChart
            }">
                <feather-icon :icon="icon" class="p-3 inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]" :style="{background: `rgba(var(--vs-${color}),.15)`}"></feather-icon>
                <div class="truncate">
                    <p class="mb-1 font-bold" style="font-size:1.5rem;">{{ this.$t(statisticTitle) }}</p>
                    <span class="mb-1" style="font-size:1.5rem;">ver. {{ statistic }} </span>
                </div>
            </div>
            <div class="flex justify-between flex-wrap" >
                <vs-button  v-if="onlyAdmin" class="mt-4 shadow-lg w-full" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" 
                    icon-pack="feather" icon="icon-repeat" @click.stop="editData(statisticTitle, statistic)">Update Version</vs-button>
            </div>

            <vs-popup class="sidebar-popup" classContent="popup-example" :title="this.$t(changeOption)" :active.sync="editPopup">
                <div>
                  <vs-input color="danger"  name="versionInfo" v-model="changeValue"  v-validate="getValidate(changeOption)" class="w-full"/>
                  <span class="text-danger text-sm" v-show="errors.has('versionInfo')">{{ errors.first('versionInfo') }}</span>
                </div>
                <vs-divider />
                <div class="float-right">
                    <vs-button @click="openConfirm()" color="primary" type="filled" :disabled="!isFormValid">{{this.$t('SUBMIT')}}</vs-button>
                    <vs-button @click="editPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
                </div>

                <vs-popup class="sidebar-popup"  :title="this.$t('WARNING')" :active.sync="confirmPopup">
                    <span class="font-bold">{{this.$t('VERSION_CHANGE_OPTION')}}</span><span class="font-bold text-primary">{{this.$t(this.changeOption)}}</span>
                    <br/>
                    <span class="font-bold">{{this.$t('VERSION_CHANGE_VALUE')}}</span><span class="font-bold text-primary"> {{this.changeValue}}</span>
                    <br/><br/>
                    <p class="font-bold">{{this.$t('VERSION_CONFIRM_MESSAGE')}}</p>
                    <p class="text-danger font-bold">{{this.$t('VERSION_SUBMIT_MESSAGE')}}</p>
                    <br/>
                    <div class="float-right">
                        <vs-button @click="acceptEdit()" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
                        <vs-button @click="confirmPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
                    </div>
                </vs-popup>
            </vs-popup>
        </div>
    </vx-card>  
</template>

<script>
import _color from '@/assets/utils/color.js'

export default{
    props: {
        icon: {
            type: String,
            required: true
        },
        statistic: {
            type: [Number, String],
            required: true,
        },
        statisticTitle: {
            type: String,
        },
        chartData: {
            // type: Array,
            // required: true
        },
        color: {
            type: String,
            default: 'primary',
        },
        colorTo: {
          type: String
        },
        // chartType: {
        //     type: String,
        //     default: 'line-chart',
        // },
        type: {
            type: String,
            default: 'line'
        },
        iconRight: {
            type: Boolean,
            default: false
        },
        hideChart: {
          type: Boolean,
          default: false,
        }
    },
    data() {
      return {
        editPopup: false,
        confirmPopup: false,
        changeOption: '',
        changeValue: '',

        appVersionValidate: {
          max:20, 
          regex: /[0-9]+\.[0-9]+\.[0-9]+$/
        },

        dvrsVersionValidate: {
          max:20, 
          regex: /AR200_[0-9]{6}_[0-9]{2,3}$/
        }
      }
    },
    watch: {
        themePrimaryColor() {
            this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex(this.color) } } });
        }
    },
    computed: {
        themePrimaryColor() {
            return this.$store.state.themePrimaryColor;
        },
        dvrsFirmwareSeq(){
            return this.$store.state.dataSystem.dvrsFirmwareSeq
        },
        onlyAdmin() {
            return this.$store.state.AppActiveUser.userRole === 'admin' ? this.$acl.check(this.$store.state.AppActiveUser.userRole) : false
        },
        isFormValid() {
          return !this.errors.any()
        },
    },
    methods: {
        editData(statisticTitle, statistic){
            this.changeOption = statisticTitle
            this.changeValue = statistic
            this.editPopup = true
        },
        openConfirm() {
            this.confirmPopup = true
        },
        acceptEdit(){
            this.$vs.loading()

            if(this.changeOption === "DVRS_FIRMWARE_VERSION"){
                
                const obj = {
                    seq: this.dvrsFirmwareSeq,
                    firmwareVersion: this.changeValue
                }      

                this.$store.dispatch("dataSystem/updateFirmwareVersion", obj)
                .then(() => {
                    this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_FILE_DOWNLOAD_COUNT_SUCCESS"))
                    this.$parent.$refs.versionUpdateTable.getData()
                    this.close()
                })
                .catch(error => { 
                    this.errorAlert(this.$t("ERROR"), error.message)
                    this.close()
                })

            }else{

                let mobileCode = 0
                if(this.changeOption === "ANDROID_APP_VERSION"){
                    mobileCode = 1
                }else{
                    mobileCode = 2
                }

                const obj = {
                    mobileCode: mobileCode,
                    appVersion: this.changeValue
                }                

                this.$store.dispatch("dataSystem/updateAppVersion", obj)
                .then(() => {
                    this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_FILE_DOWNLOAD_COUNT_SUCCESS"))
                    this.$parent.$refs.versionUpdateTable.getData()
                    this.close()
                })
                .catch(error => { 
                    this.errorAlert(this.$t("ERROR"), error.message)
                    this.close()
                })
                
            }
        },
        close(){
            this.confirmPopup = false
            this.editPopup = false
            
            this.$store.dispatch("dataSystem/fetchAppVersion")
            this.$store.dispatch("dataSystem/fetchFirmwareVersion").then(() =>{
                this.$vs.loading.close()
            })
        },
        getValidate(statisticTitle){
          if(statisticTitle === "DVRS_FIRMWARE_VERSION"){
            return this.dvrsVersionValidate
          }
          return this.appVersionValidate
        }
    },
}
</script>
